import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from 'environments/environment';

import { BannerMessage, InformationStructure } from '@model';
import { SxErrorService } from 'app/services/sx-error.service';

@Injectable()
export class InformationService {
  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getInformation(): Observable<InformationStructure> {
    return this.http
      .get<InformationStructure>(`${environment.apiEndpoint}/information`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  getBanners(): Observable<BannerMessage[]> {
    return this.http
      .get<BannerMessage[]>(`${environment.apiEndpoint}/information/bannerMessages`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
